import template from './item.html';
import controller from './item.controller';
import './item.scss';

let itemComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default itemComponent;


// WEBPACK FOOTER //
// ./client/app/components/item/item.component.js